/**
 * Created by edust on 8/13/2018.
 */

setTimeout(function () {
		let loginModal = $('#loginModal');
    if (!user) {
        let assisttype = localStorage.getItem('assistant');
        if (assisttype != 'fclosed' && !loginModal.is(':visible')) {

            /!*when assistnat open then selected filter will populate*!/
            $('#selected').find('.tag').each(function () {
                let assistTags = $(this).attr('data-id');
                $('#AssistantModal span[data-id ="' + assistTags + '"]').addClass('active-assist');
            });
            $('.button_1O').hide();
						checkSmartSearchLogin();
            // $('#AssistantModal').modal('show', {backdrop: 'static', keyboard: false});
        }
    }
}, 30000);


$('#AssistantModal').on('hidden.bs.modal', function () {
    $('.button_1O').show();
    localStorage.setItem('assistant', 'fclosed');
});


